import { TranscriptSummaryRefreshContainer } from '@/containers/ConferenceTag.Summary/Transcript.Refresh';

type Props = ChildrenProps & ITranscriptId;

export const TranscriptSummaryContainer = ({ children, transcriptId }: Props) => {

  return (
    // <TranscriptSummaryFeedbackFormContainer transcriptId={transcriptId}>
    <TranscriptSummaryRefreshContainer transcriptId={transcriptId}>
      {/* <TranscriptSummaryCitationsContainer transcriptId={transcriptId}>
        <TranscriptSummaryFeedbackSummarysContainer transcriptId={transcriptId}>
          <TranscriptSummaryRatingsContainer transcriptId={transcriptId}>
            <TranscriptSummaryVersionsContainer transcriptId={transcriptId}> */}
      {children}
      {/* </TranscriptSummaryVersionsContainer>
          </TranscriptSummaryRatingsContainer>
        </TranscriptSummaryFeedbackSummarysContainer>
      </TranscriptSummaryCitationsContainer> */}
    </TranscriptSummaryRefreshContainer>
    // </TranscriptSummaryFeedbackFormContainer>
  );
};